//#region src/utils/string.ts
function capitalizeFirstLetter(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}
//#endregion
export { capitalizeFirstLetter };
